import { css } from 'styled-components';
import { mediaQuery } from 'src/app/styles/helper';

export interface OrderProps {
  order?: number;
  orderSm?: number;
  orderMd?: number;
  orderLg?: number;
  orderXl?: number;
  order2xl?: number;
}

export type StyledOrderProps = {
  [K in keyof OrderProps as `$${K}`]: OrderProps[K];
};

export const orderStyles = css<StyledOrderProps>`
  ${({ $order }) => $order !== undefined && `order: ${$order};`}

  ${({ $order2xl }) =>
    $order2xl !== undefined &&
    mediaQuery(
      '2xl',
      css`
        order: ${$order2xl};
      `
    )}

  ${({ $orderXl }) =>
    $orderXl !== undefined &&
    mediaQuery(
      'xl',
      css`
        order: ${$orderXl};
      `
    )}

  ${({ $orderLg }) =>
    $orderLg !== undefined &&
    mediaQuery(
      'lg',
      css`
        order: ${$orderLg};
      `
    )}

  ${({ $orderMd }) =>
    $orderMd !== undefined &&
    mediaQuery(
      'md',
      css`
        order: ${$orderMd};
      `
    )}

  ${({ $orderSm }) =>
    $orderSm !== undefined &&
    mediaQuery(
      'sm',
      css`
        order: ${$orderSm};
      `
    )}
`;
